<template>
  <div class="menu-category">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '3' : '2'" class="d-flex">
          <v-app-bar-nav-icon v-if="showNavBack" @click="navBack">
            <v-icon v-if="$appMode == 1 && catID == 0 && $route.params.item == null">mdi-storefront-outline</v-icon>
            <v-icon v-else>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>

          <v-app-bar-nav-icon v-if="$appMode == 0" @click="onClickMenu"></v-app-bar-nav-icon>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '6' : '8'" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom)
              }}<span class="header-title2-feature">{{ headerCategoryTitle }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col :cols="$vuetify.breakpoint.mdAndUp ? '3' : '2'" align-self="end" style="text-align: right">
          <v-badge
            v-show="!$store.getters.storeMenuMode"
            :value="$store.state.order.qtyTotal"
            :content="$store.state.order.qtyTotal"
            color="accent"
            class="accentText--text"
            overlap
            offset-x="20"
            offset-y="20"
          >
            <v-app-bar-nav-icon @click="checkOutClicked">
              <v-icon>mdi-cart-outline</v-icon>
            </v-app-bar-nav-icon>
          </v-badge>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container
      v-if="$store.state.store != null"
      :class="[/*{ 'mb-16': ua_isMobile() },*/ 'mb-16', 'mt-n3', 'x-no-max-width']"
    >
      <v-row>
        <img
          :src="$store.state.store.info.coverUri"
          id="store-cover"
          class="store-cover"
          v-if="$store.state.store.info.coverUri != null && $store.state.store.info.coverUri != ''"
        />
        <img
          :src="$store.state.store.info.logoUri"
          id="store-logo"
          class="store-logo"
          v-else-if="$store.state.store.info.logoUri != null && $store.state.store.info.logoUri != ''"
        />
      </v-row>

      <v-row
        class="store-message"
        v-if="storeMessage != '' && $t(storeMessage) != storeMessage && $t(storeMessage) != ''"
      >
        <v-col v-html="$t(storeMessage)">
          <!-- {{ $t(storeMessage) }} -->
        </v-col>
      </v-row>

      <div v-if="!$store.getters.acceptOrder && !$store.getters.storeMenuMode" class="not-accept-order">
        <v-chip color="accent" text-color="accentText">
          {{ $t("not_acception_order") }}
        </v-chip>
      </div>

      <ul
        id="cat-list"
        :class="['cat-list', ua_isMobile() ? 'cat-list-mobile' : 'cat-list-desktop']"
        v-if="orderMenuButtonsOnTopBar"
      >
        <v-btn-toggle v-model="$store.state.orderMenu" mandatory color="accent" style="padding: 10px 0px;">
          <v-btn small>
            {{ $t("MENU.menu") }}
          </v-btn>
          <v-btn small>
            {{ $t("redeem") }}
          </v-btn>
        </v-btn-toggle>
      </ul>

      <PromoList
        v-if="
          $appMode == 0 &&
            $store.state.orderMenu == 0 &&
            catID == 0 &&
            $store.state.order.tableID == 0 &&
            !$store.getters.storeMenuMode
        "
      ></PromoList>

      <v-row class="menu-row">
        <v-col class="menu-col" cols="12" sm="6" md="6" lg="4" x-xl="3" v-for="cat in categories" :key="cat.ID">
          <MenuCategoryEle :cat="cat" @categoryClicked="categoryClicked"></MenuCategoryEle>
        </v-col>
      </v-row>
    </v-container>

    <!--     <v-fab-transition v-show="!$vuetify.breakpoint.mdAndUp">
      <v-btn color="primary" class="primaryText--text" fixed bottom right fab @click="searchMenuItem">
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </v-fab-transition> -->

    <BottomToolbar x-v-show="!$vuetify.breakpoint.mdAndUp"></BottomToolbar>
    <LoginSelector
      ref="loginSelector"
      :show="showLoginSelector"
      @cancel="loginCancel()"
      @completed="loginCompleted()"
    ></LoginSelector>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <AddShortcutToHomeScreen v-if="$store.state.rootName == 'MenuCategory'"></AddShortcutToHomeScreen>
  </div>
</template>

<script>
import AddShortcutToHomeScreen from "@/components/AddShortcutToHomeScreen.vue";
import BottomToolbar from "@/components/BottomToolbar.vue";
import LoginSelector from "@/components/LoginSelector.vue";
import MenuCategoryEle from "@/components/MenuCategoryEle.vue";
import PromoList from "@/components/PromoList.vue";

export default {
  beforeRouteLeave(to, from, next) {
    let promoListEle = document.getElementById("promo-list");
    if (promoListEle != null) {
      this.promoListScrollLeft = promoListEle.scrollLeft;
    }
    next();
  },

  components: {
    AddShortcutToHomeScreen,
    BottomToolbar,
    LoginSelector,
    MenuCategoryEle,
    PromoList,
  },

  data() {
    return {
      refreshing: false,

      prevSessionKey: "",

      catID: 0,
      showLoginSelector: false,
      promoListScrollLeft: 0,
    };
  },

  activated() {
    console.log("menu-category activated", this.$route.params);

    if (this.$route.params.catID != null) {
      this.catID = this.$route.params.catID;
    }

    if (
      (this.$appMode == 0 &&
        (this.$store.state.routeFrom.name == null || this.$store.state.routeFrom.name == "StoreHome")) ||
      (this.$appMode == 1 &&
        (this.$store.state.routeFrom.name == "Stores" || this.$store.state.routeFrom.name == "Offer"))
    ) {
      if (
        this.$store.state.order.orderType == this.$store.state.OT_DINEIN &&
        this.$store.getters.storeCovidContactFormUrl != ""
      ) {
        let submittedTime = this.getCovidFormSubmitTime();
        let now = new Date();
        if (submittedTime == null || now.getTime() - submittedTime.getTime() > 86400000) {
          this.$root
            .customFormDialog("COVID-19 Contact Tracing Form", this.$store.getters.storeCovidContactFormUrl, true)
            .then(submit => {
              if (submit) {
                console.log("form submitted");
                this.setCovidFormSubmitTime();
              }
            });
        }
      }

      this.refreshing = true;
      this.rest_canAcceptOrder(this.$store.state.order.orderType).then(resp => {
        this.$store.state.storeOrderHours = resp;

        if (this.$appMode == 1) {
          let item = this.$route.params.item;
          if (item != null) {
            if (this.$store.getters.acceptOrder) {
              if (item.bItems != null && item.bItems.length > 0) {
                this.navName("OrderBundle", this.$route.params);
              } else {
                let oi = this.itemToOrderItem(item);
                this.addOrderItem(oi);
              }
            } else {
              this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
            }
          }
        }
      });
      this.refreshing = false;

      this.promoListScrollLeft = 0;
    }

    let msec = this.$vuetify.breakpoint.mdAndUp ? 200 : 0;
    setTimeout(() => {
      let promoListEle = document.getElementById("promo-list");
      if (promoListEle != null) {
        promoListEle.scrollLeft = this.promoListScrollLeft;
      }
    }, msec);
  },

  computed: {
    showNavBack() {
      return this.$store.state.rootName != "MenuCategory";
    },

    headerCategoryTitle() {
      let title = this.$t("category");
      if (this.category != null) title = this.$store.getters.categoryDescr(this.category);

      return title;
    },

    orderMenuButtonsOnTopBar() {
      return this.$store.state.pointEnabled && this.$store.state.redeemMenu.length > 0 && this.category == null;
    },

    storeMessage() {
      if (this.$store.state.order.orderType == this.$store.state.OT_DINEIN) return "dinein-message";
      else if (this.$store.state.order.orderType == this.$store.state.OT_TAKEOUT) return "takeout-message";
      else if (this.$store.state.order.orderType == this.$store.state.OT_DELIVERY) return "delivery-message";
      else return "";
    },

    menu() {
      let n_menu = [];
      if (this.$store.state.orderMenu == 1) {
        n_menu = this.$store.state.redeemMenu;
      } else {
        n_menu = this.$store.state.menu;
      }

      if (n_menu == null) {
        return [];
      } else {
        n_menu = n_menu.filter(cat => cat.ID < 0 || cat.menuTypes.includes(this.$store.state.order.orderType));
      }

      return n_menu;
    },

    categories() {
      let m_categories = this.menu.filter(cat => cat.pID == this.catID);
      if (
        this.catID == 0 &&
        m_categories.length == 1 &&
        m_categories[0].items.length == 0 &&
        m_categories[0].child_count > 0
      ) {
        m_categories = this.menu.filter(cat => cat.pID == m_categories[0].ID || cat.ID < 0);
      }
      return m_categories;
    },

    category() {
      return this.menu.find(cat => cat.ID == this.catID);
    },
  },

  methods: {
    onClickMenu() {
      this.$store.state.appBar.showDrawer = true;
    },

    categoryClicked(cat) {
      if (cat.ID == -2 && this.$store.state.member == null) {
        this.$root.memberLoginDialog().then(logined => {
          if (logined) {
            this.navNextView(cat);
          }
        });
      } else {
        this.navNextView(cat);
      }
    },

    navNextView(cat) {
      console.log("navNextView cat", cat);

      if (cat.child_count > 0) {
        this.navName("MenuCategory", { catID: cat.ID });
      } else {
        this.navName("MenuItem", { catIDs: [cat.ID] });
      }
    },

    checkOutClicked() {
      if (this.$store.state.order.orderItems.length == 0) return;

      this.rest_canAcceptOrder(this.$store.state.order.orderType).then(resp => {
        this.$store.state.storeOrderHours = resp;

        if (this.$store.getters.acceptOrder) {
          if (this.$store.state.order.login == null) {
            if (
              this.$store.state.memberEnabled &&
              this.$store.state.memberOptional &&
              this.$store.state.member == null
            ) {
              this.showLoginSelector = true;
            } else {
              this.$refs.loginSelector.login(this.$store.state.memberEnabled);
            }
          } else {
            this.loginCompleted();
          }
        } else {
          this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));

          return;
        }
      });
    },

    loginCancel() {
      this.showLoginSelector = false;
    },

    loginCompleted() {
      this.showLoginSelector = false;
      this.calculateTotal();
      this.navName("Checkout");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.store-message {
  padding: 10px 10px;
  background-color: var(--v-secondary-lighten1);
  color: var(--v-secondaryText-base);
  text-align: center;

  .col {
    padding: 0px;
  }
}

.not-accept-order {
  text-align: center;
  padding: 10px;
}

.cat-list {
  position: sticky;
  top: $header-height;
  background-color: white;
  z-index: 2;
  margin: 0px -12px;
  padding: 0px 8px;
}

.v-slide-group__prev {
  min-width: 30px;
}

.v-slide-group__next {
  min-width: 30px;
}
</style>
